module.exports = __webpack_public_path__ + "static/nxrt-mainpage5-c4ddd8f30c44941d496f2bc3adea03c2.jpg";